import { getHashedEmail, queueAnalyticsEvent, SeoEvent } from 'lib/gtm'
import type { CustomerTypes } from 'modules/customer'
import { isCustomerAdult } from 'modules/customer'

interface searchProductsProps {
  customer?: CustomerTypes
  searchQuery: string
}

export const searchProductsSeo = ({
  customer,
  searchQuery
}: searchProductsProps) => {
  const eventData = {
    event: SeoEvent.SEARCH, //constant
    type: 'other events', //constant
    user_id: customer?.code || undefined, //User ID from crm if logged in, if not we return undefined
    user_adult: isCustomerAdult(customer?.dateOfBirth), //1 if customer have more than 18 years, 0 - if no, if no value we return undefined
    hashed_email: getHashedEmail(customer?.email), //customer email in md5 - if logged in, if not we return undefined
    search_term: searchQuery //search term
  }

  queueAnalyticsEvent(eventData)
}
